module.exports = __webpack_public_path__ + "static/media/bg1.eb2f742c.png";